import { useEffect } from "react";
import { useSite } from "@/context/SiteContext";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function useSEO({ title, description, image, jsonLd } = {}) {
  const { settings } = useSite();
  const seo = settings?.seo || {};
  useEffect(() => {
    const t = title ? `${title} | The Transformed Mind Life` : seo.default_title || "The Transformed Mind Life";
    const d = description || seo.default_description;
    const img = image || seo.og_image;
    document.title = t;
    setMeta("name", "description", d);
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:image", img && img.startsWith("/") ? window.location.origin + img : img);
    setMeta("property", "og:url", window.location.href);
    setMeta("name", "twitter:card", "summary_large_image");
    let s = document.getElementById("jsonld");
    if (jsonLd) {
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = "jsonld";
        document.head.appendChild(s);
      }
      s.textContent = JSON.stringify(jsonLd);
    } else if (s) s.remove();
  }, [title, description, image, jsonLd, seo.default_title, seo.default_description, seo.og_image]);
}
